<template>
  <v-tabs v-model="tabs">
    <v-tab :key="1">{{ labels.profile }}</v-tab>
    <v-tab-item :key="1">
      <v-card flat>
        <v-toolbar dense color="grey lighten-5" flat>
          <v-icon>mdi-format-align-justify</v-icon>
          <v-toolbar-title class="toolbar-title-2">{{ labels.general }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex xs2>
                <v-subheader class="queryLabel">{{ labels.interNoAe }}</v-subheader>
              </v-flex>
              <v-flex xs2>
                <v-subheader class="queryLabel">{{ labels.interType }}</v-subheader>
              </v-flex>
              <v-flex xs2>
                <v-subheader class="queryLabel">{{ labels.titleName }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.abbrevName }}</v-subheader>
              </v-flex>
              <v-flex xs2>
                <div class="queryValue">{{ formatBoolean(interForm.interNoAe) }}</div>
              </v-flex>
              <v-flex xs2>
                <div class="queryValue">{{ interForm.interType }}</div>
              </v-flex>
              <v-flex xs2>
                <div class="queryValue">{{ interForm.titleName }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ interForm.abbrevName }}</div>
              </v-flex>

              <v-flex xs2>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              </v-flex>
              <v-flex xs2>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              </v-flex>
              <v-flex xs2>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
              </v-flex>
              <v-flex xs2>
                <div class="queryValue">{{ interForm.strCreatedBy }}</div>
              </v-flex>
              <v-flex xs2>
                <div class="queryValue">{{ formatDate(interForm.createdDate) }}</div>
              </v-flex>
              <v-flex xs2>
                <div class="queryValue">{{ interForm.strModifiedBy }}</div>
              </v-flex>
              <v-flex xs6>
                <div class="queryValue">{{ formatDate(interForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-flex xs12 class="mt-2">
          <v-expansion-panels v-model="toogleArray" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <span class="headerTitle">Contact & Details</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.contact }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.telNo1 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.telNo2 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.contact }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.telNo1 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.telNo2 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.telNo3 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.telNo4 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.telNo5 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.telNo3 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.telNo4 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.telNo5 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.add1 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.add2 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.add3 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.add1 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.add2 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.add3 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.add4 }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.postalCode }}</v-subheader>
                      </v-flex>
                      <v-flex xs2> </v-flex>
                      <v-flex xs2> </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.add4 }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.postalCode }}</div>
                      </v-flex>
                      <v-flex xs2> </v-flex>
                      <v-flex xs2> </v-flex>

                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.email }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.web }}</v-subheader>
                      </v-flex>
                      <v-flex xs4> </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.email }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.web }}</div>
                      </v-flex>
                      <v-flex xs4> </v-flex>

                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.dateOpened }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.dateClosed }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.commType }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ formatDate(interForm.dateOpened) }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ formatDate(interForm.dateClosed) }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.commType }}</div>
                      </v-flex>

                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.cty }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.regAgt }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.branch }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.cty }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.regAgt }}</div>
                      </v-flex>

                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.gstRegNo }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.gstRegDate }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.gstKeyRegAgt }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.gstRegNo }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ formatDate(interForm.gstRegDate) }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.gstKeyRegAgt }}</div>
                      </v-flex>

                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.crPer }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.crLim }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.crLimCurr }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.crPer }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.crLim }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.crLimCurr }}</div>
                      </v-flex>

                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.perDebtTran }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.blackList }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.inactive }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ formatBoolean(interForm.perDebtTran) }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ formatBoolean(interForm.blackList) }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ formatBoolean(interForm.inactive) }}</div>
                      </v-flex>

                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.suspended }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.insdDisc }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.execIC }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ formatBoolean(interForm.suspended) }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.insdDisc }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.execIC }}</div>
                      </v-flex>

                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.schemeMand }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.stmtType }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <v-subheader class="queryLabel">{{ labels.defNoPrtDrCr }}</v-subheader>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ formatBoolean(interForm.schemeMand) }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.stmtType }}</div>
                      </v-flex>
                      <v-flex xs4>
                        <div class="queryValue">{{ interForm.defNoPrtDrCr }}</div>
                      </v-flex>

                      <v-flex xs5>
                        <v-subheader class="queryLabel">{{ labels.grpRefStmt }}</v-subheader>
                      </v-flex>
                      <v-flex xs5>
                        <v-subheader class="queryLabel">{{ labels.grpRefAge }}</v-subheader>
                      </v-flex>
                      <v-flex xs5>
                        <div class="queryValue">{{ interForm.grpRefStmt }}</div>
                      </v-flex>
                      <v-flex xs5>
                        <div class="queryValue">{{ interForm.grpRefAge }}</div>
                      </v-flex>

                    </v-layout>
                    <v-layout>
                      <v-flex xs5>
                        <v-subheader class="queryLabel">{{ labels.isDM }}</v-subheader>
                      </v-flex>
                      <v-flex xs5>
                        <v-subheader class="queryLabel">{{ labels.prtBuyerCreatedTaxInv }}</v-subheader>
                      </v-flex>
                    </v-layout>
                    <v-layout>
                      <v-flex xs5>
                        <div class="queryValue">{{ formatBoolean(interForm.isDM) }}</div>
                      </v-flex>
                       <v-flex xs5>
                        <div class="queryValue">{{ interForm.prtBuyerCreatedTaxInv }}</div>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <!-- <v-flex lg6 md12 xs12>
          <v-btn color="primary" v-if="checkAccess(['intermediaryReview'])" @click="doReview">
            Edit Intermediary
            <v-icon right>mdi-pencil</v-icon>
          </v-btn>
        </v-flex> -->
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      tabs: 0,
      toogleArray: [0],
      labels: {
        profile: 'Profile',
        inter: 'Intermediary Reference',
        intermediaryName: 'Intermediary Name',
        name2: 'Intermediary Name 2',
        name3: 'Intermediary Name 3',
        name4: 'Intermediary Name 4',
        abbrevName: 'Abbreviated Name',
        interNoAe: 'Intermediary Reference No.',
        interGroup: 'Intermediary Group',
        interType: 'Intermediary Type',
        titleName: 'Title',
        contact: 'Contact Person',
        telNo1: 'Telephone',
        telNo2: 'Telephone 2',
        telNo3: 'Telephone 3',
        telNo4: 'Telephone 4',
        telNo5: 'Telephone 5',
        officeNo: 'Office No.',
        faxNo: 'Fax No.',
        add1: 'Address',
        add2: 'Address 2',
        add3: 'Address 3',
        add4: 'Address 4',
        postalCode: 'Postal Code',
        email: 'Email',
        web: 'Web page',
        general: 'General',
        addrCtry: 'Country',
        addrState: 'State',
        commType: 'Commission Entitlement',
        dateOpened: 'Date Opened',
        dateClosed: 'Date Closed',
        suspended: 'Is Suspended?',
        blackList: 'Is blackListed?',
        inactive: 'Is InActive?',
        branch: 'Home Branch',
        cty: 'Country',
        regAgt: 'Registered Agent',
        // regCat: 'Registration Category',
        gstRegNo: 'GST Registration No',
        gstRegDate: 'GST Registration Date',
        gstKeyRegAgt: 'GST Key Registered Agent',
        // cashCR: 'Cash or Credit',
        crPer: 'Credit Period(days)',
        crLim: 'Credit Limit',
        crLimCurr: 'Credit Limit Currency',
        perDebtTran: 'Permit Debtor Transaction',
        // prtBondNo: 'Print Bond No on Schedule',
        insdDisc: 'Permit Insured Discount',
        execIC: 'Executive in charge',
        schemeMand: 'Scheme Mandatory',
        stmtType: 'Statement Type',
        grpRefStmt: 'Group Intermediary No. for Statement',
        grpRefAge: 'Group Intermediary No. for Ageing',
        defNoPrtDrCr: 'Default No. Dr / Cr Note',
        isDM: 'Is DM Intermediary?',
        prtBuyerCreatedTaxInv: 'Print Buyer-Created Tax Invoice for Comm GST Status',
        createdBy: 'Created by',
        createdDate: 'Created Date',
        modifiedBy: 'Modified by',
        modifiedDate: 'Modified Date'
      },
      interForm: {
        inter: undefined,
        intermediaryName: undefined,
        name2: undefined,
        name3: undefined,
        name4: undefined,
        abbrevName: undefined,
        interNoAe: true,
        interGroupCode: undefined,
        interGroupName: undefined,
        interType: undefined,
        titleName: undefined,
        contact: undefined,
        telNo1: undefined,
        telNo2: undefined,
        telNo3: undefined,
        telNo4: undefined,
        telNo5: undefined,
        officeNo: undefined,
        faxNo: undefined,
        add1: undefined,
        add2: undefined,
        add3: undefined,
        add4: undefined,
        postalCode: undefined,
        email: undefined,
        web: undefined,
        addrCtry: undefined,
        addrState: undefined,
        commType: undefined,
        dateOpened: new Date(),
        dateClosed: undefined,
        suspended: false,
        blackList: false,
        inactive: false,
        branch: undefined,
        cty: undefined,
        regAgt: undefined,
        // regCat: undefined,
        gstRegNo: undefined,
        gstRegDate: undefined,
        gstKeyRegAgt: undefined,
        // cashCR: undefined,
        crPer: 0,
        crLim: 0,
        crLimCurr: undefined,
        perDebtTran: false,
        // prtBondNo: undefined,
        insdDisc: undefined,
        execIC: undefined,
        schemeMand: false,
        stmtType: undefined,
        grpRefStmt: undefined,
        grpRefAge: undefined,
        defNoPrtDrCr: 0,
        isDM: false,
        prtBuyerCreatedTaxInv: undefined,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined
      },
      menu: []
    }
  },
  computed: {
    ...mapGetters(['checkAccess'])
  },
  methods: {
    doReview() {
      this.$router.push({ name: 'reviewProfile', params: { inter: this.interForm.inter, interGroupCode: this.interForm.interGroupCode } })
    },
    queryLimit() {
      this.$toast.warning('Cannot do this in query mode')
    },
    doBack() {
      this.$router.push({ name: 'intermediaries' })
    },
    formatDate(xDate) {
      if (xDate === null) {
        return undefined
      } else {
        return formatDisplayDate(xDate)
      }
    },
    formatBoolean(val) {
      if (val === undefined) {
        return 'No'
      } else {
        if (val === true) {
          return 'Yes'
        } else {
          return 'No'
        }
      }
    }
  },
  created() {
    this.interForm = this.$store.state.adminInter.intermediary
  },
  props: ['inter', 'interGroupCode']
}
</script>

<style lang="scss">
</style>
